const bleEventsType = {
    deviceUpdated: `deviceUpdated`,
    connectionChanged: 'connectionChanged',
    characteristicMessage: 'characteristicMessage',
    onExtensionMessage: 'onExtensionMessage'
}

export default bleEventsType;